/**
 * doc/12 §3.7 — early-user group entry point.
 *
 * A quiet fixed-position pill in the bottom-right of the app shell.
 * Click → popover with the WeChat group QR. For the friends-circle
 * launch the group IS the support/feedback/retention channel — no
 * in-app ticket system.
 *
 * The QR image is served from /qun.png (drop the real image into
 * web/public/). Until it exists, the popover shows a text fallback so
 * the surface ships before the group does.
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function FeedbackFab() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [qrBroken, setQrBroken] = useState(false);

  return (
    <>
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{ position: 'fixed', inset: 0, zIndex: 60 }}
        />
      )}
      <div
        style={{
          position: 'fixed',
          right: 18,
          bottom: 18,
          zIndex: 61,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: 10,
        }}
      >
        {open && (
          <div
            style={{
              width: 240,
              background: 'white',
              border: '1px solid var(--rule)',
              borderRadius: 10,
              boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
              padding: 16,
              textAlign: 'center',
            }}
          >
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: 'var(--ink-0)',
                marginBottom: 4,
              }}
            >
              {t('feedback.title')}
            </div>
            <div
              style={{
                fontSize: 12,
                lineHeight: 1.5,
                color: 'var(--ink-2)',
                marginBottom: 12,
              }}
            >
              {t('feedback.body')}
            </div>
            {qrBroken ? (
              <div
                style={{
                  fontSize: 12,
                  color: 'var(--ink-3)',
                  padding: '24px 8px',
                  border: '1px dashed var(--rule)',
                  borderRadius: 8,
                }}
              >
                {t('feedback.qrFallback')}
              </div>
            ) : (
              <img
                src="/qun.png"
                alt={t('feedback.qrAlt')}
                onError={() => setQrBroken(true)}
                style={{
                  width: 180,
                  height: 180,
                  borderRadius: 8,
                  border: '1px solid var(--rule)',
                  objectFit: 'cover',
                }}
              />
            )}
          </div>
        )}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          title={t('feedback.title')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            padding: '8px 14px',
            background: open ? 'var(--ink-0)' : 'white',
            color: open ? 'white' : 'var(--ink-1)',
            border: '1px solid var(--rule)',
            borderRadius: 999,
            fontSize: 12,
            fontWeight: 500,
            fontFamily: 'inherit',
            cursor: 'pointer',
            boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
          }}
        >
          <span aria-hidden="true" style={{ fontSize: 13 }}>
            ✦
          </span>
          {t('feedback.fab')}
        </button>
      </div>
    </>
  );
}
